"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALES = exports.LANGUAGES = void 0;
var LANGUAGES;

(function (LANGUAGES) {
  LANGUAGES["en"] = "en";
  LANGUAGES["fr"] = "fr";
  LANGUAGES["de"] = "de";
  LANGUAGES["it"] = "it";
})(LANGUAGES = exports.LANGUAGES || (exports.LANGUAGES = {}));

var LOCALES;

(function (LOCALES) {
  LOCALES[LOCALES["en-CA"] = 0] = "en-CA";
  LOCALES[LOCALES["en-CH"] = 1] = "en-CH";
  LOCALES[LOCALES["en-GB"] = 2] = "en-GB";
  LOCALES[LOCALES["en-US"] = 3] = "en-US";
  LOCALES[LOCALES["fr-CA"] = 4] = "fr-CA";
  LOCALES[LOCALES["fr-CH"] = 5] = "fr-CH";
  LOCALES[LOCALES["de-CH"] = 6] = "de-CH";
  LOCALES[LOCALES["it-CH"] = 7] = "it-CH";
  LOCALES[LOCALES["de-DE"] = 8] = "de-DE";
  LOCALES[LOCALES["en-NZ"] = 9] = "en-NZ";
})(LOCALES = exports.LOCALES || (exports.LOCALES = {}));